import React, { useState } from "react";
import _ from "lodash";
import DataGrid, {
  Column,
  Grouping,
  GroupPanel,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { Button, Col, Form, FormLabel, Row } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import TasksModalEdit from "./TasksModalEdit";
import { saveData } from "../helpers";

const MyTasksByProject = (props) => {
  const [t,i18n] = useTranslation("mytasks")
  const { myTasks, handleShow } = props;
  const [startDate, setStartDate]= useState(null);
  const [endDate, setEndDate]= useState(null);
  const [compStartDate, setCompStartDate]= useState(null);
  const [compEndDate, setCompEndDate]= useState(null);
  const [saveInfo, setSaveInfo]= useState({})

  const getDateFromForm = (e) => {
    e.preventDefault();
    let dateValue = e.target.startDate.value
    let datePieces = dateValue.split("/")
    let dateCompa = new Date(datePieces[2],(datePieces[1]-1), datePieces[0])
    setCompStartDate((dateCompa.getTime()) - (18000000))

    let dateValueEnd= e.target.endDate.value;
    let datePiecesEnd = dateValueEnd.split("/")
    let dateCompaEnd = new Date(datePiecesEnd[2],(datePiecesEnd[1]-1), datePiecesEnd[0])
    setCompEndDate(dateCompaEnd.getTime() - (18000000))
  }


  const taskByProject = () => {
    if(compStartDate === null) {
      return myTasks.filter((task) => {
        return (props.filterTask.showCompleted
          ? true
          : task.PctCompletado < 100) && (props.filterTask.onlyFeatured
          ? task.Destacada
          : true);
      })
    }else if( compStartDate !== null && compEndDate !== null ) {
      let taskFilter = myTasks.filter((task) => {
        return (props.filterTask.showCompleted
          ? true
          : task.PctCompletado < 100) && (props.filterTask.onlyFeatured
          ? task.Destacada    
          : true);
      })

      if(compStartDate === compEndDate){
        let beforeDay = compStartDate 
        let afterDay = compEndDate + 18000700
        let taskFilterByDate = taskFilter.filter( ta => {
          if(ta.nFechaInicioReal === null) {
            ta.nFechaInicioReal = ta.nFechaInicioProg
          }else{
            ta.nFechaInicioReal = ta.nFechaInicioReal 
          }
          return (ta.nFechaInicioProg >= beforeDay && ta.nFechaInicioProg  <= afterDay) || (ta.nFechaInicioReal >= beforeDay && ta.nFechaInicioReal  <= afterDay) } )
      return taskFilterByDate

      } else if (compStartDate !== compEndDate) {
        let beforeDay = compStartDate
        let afterDay = compEndDate + 18000700
        let taskFilterByDate = taskFilter.filter( ta => { 
          if(ta.nFechaInicioReal === null) {
            ta.nFechaInicioReal = ta.nFechaInicioProg
          }
          return (ta.nFechaInicioProg >= beforeDay && ta.nFechaInicioProg  <= afterDay) || (ta.nFechaInicioReal >= beforeDay && ta.nFechaInicioReal  <= afterDay) } )
      return taskFilterByDate
      }
    }
  }


  const columns = [
    {
      caption: t("tasks_projects_table_column_manager"),
      selector: "Gerente",
      width: 180,
      customRender: (row) => {
        return <span>{row.data.Gerente}</span>;
      },
    },
    {
      caption: t("tasks_projects_table_column_methodology"),
      selector: "Metodologia",
      width: 110,
    },
    {
      caption: t("tasks_projects_table_column_activity"),
      selector: "NombreActividad",
      customRender: (row) => {
        return (
          <>
            <div>
              <span
                onClick={() => {
                  setSaveInfo(row.data);
                  handleShow();
                }}
                style={{ cursor: "pointer", color: "red" }}
              >
                {row.data.Destacada && (
                  <small>
                    <i class="fa fa-star text-warning mr-1"></i>{" "}
                  </small>
                )}
                {row.data.NombreActividad}
              </span>
            </div>
          </>
        );
      },
    },
    {
      caption: t("tasks_projects_table_column_plannedstart"),
      selector: "vFechaInicioProg",
      width: 110,
    },
    {
      caption: t("tasks_projects_table_column_plannedend"),
      selector: "vFechaFinProg",
      width: 110,
    },
    {
      caption: t("tasks_projects_table_column_realstart"),
      selector: "FechaInicioReal",
      width: 110,
    },
    {
      caption:t("tasks_projects_table_column_realend") ,
      selector: "FechaFinReal",
      width: 110,
    },
    {
      caption: t("tasks_projects_table_column_avanced"),
      selector: "PctCompletado",
      width: 110,
      customRender: (row) => {
        return <span>{row.data.PctCompletado}%</span>;
      },
    },
  ];

  return (
    <React.Fragment>

<Form
        onSubmit= {getDateFromForm}
      >
        <Row>
          <Col>
            <Form.Group className="mb-0" >
            <FormLabel>{t("tasks_projects_searchdate_tilte")}</FormLabel> <br/>
            <Row className="task-group-1">
              <Col xl={2} md={2} >
                <ReactDatePicker
                  selected={startDate}
                  dateFormat="dd/MM/yyyy"
                  filterDate ={date => date.getDay() !== 6 && date.getDay() !== 0}
                  wrapperClassName="w-100"
                  className="form-control"
                  required
                  placeholderText={t("tasks_projects_searchdate_from")}
                  name="startDate"
                  fixedHeight={false}
                  onChange={(date) => { setStartDate(date)}}
                />
              </Col>
              <Col xl={2} md={2} >
                <ReactDatePicker
                  selected={endDate}
                  dateFormat="dd/MM/yyyy"
                  filterDate ={date => date.getDay() !== 6 && date.getDay() !== 0}
                  wrapperClassName="w-100"
                  className="form-control"
                  placeholderText={t("tasks_projects_searchdate_to")}
                  name="endDate"
                  fixedHeight={false}
                  required
                  onChange={(date) => { setEndDate(date)}}
                />
              </Col>
              <Col className="align-items-end d-flex">
                {compStartDate && (
                  <Button
                    className="mb-5 mb-sm-3 mr-2"
                    variant="light"
                    onClick={() => { 
                      setCompStartDate(null)
                      setCompEndDate(null)
                    }}
                  >
                    <i className="fa fa-times"></i>
                   </Button>
                   )}
                  <Button variant="outline-primary" className="mb-5 mb-sm-3" type="submit">
                    <i className="fa far fa-search"/>
                  </Button>
              </Col>
            </Row>
            </Form.Group>
          </Col>
            
        </Row>
      </Form>
      <hr />
      <DataGrid
        // dataSource={myTasks.filter((task) =>
        //   showCompleted ? true : task.PctCompletado < 100
        // )}
        dataSource={taskByProject()}
        allowColumnReordering={true}
        showBorders={true}
        //   onContentReady={this.onContentReady}
      >
        <GroupPanel visible={true} />
        <SearchPanel visible={true} placeholder={t("tasks_projects_searchbox")} />
        <Grouping autoExpandAll={false} />
        <Column dataField="NombreProyecto" caption={t("tasks_projects_table_column_project")} groupIndex={0} />
        {columns.map((itmCol, index) => {
          return (
            <Column
              key={index}
              dataField={itmCol.selector}
              caption={itmCol.caption}
              width={itmCol.width}
              cellRender={(row) => {
                return (
                  <>
                    {itmCol.customRender ? itmCol.customRender(row) : row.text}
                  </>
                );
              }}
            />
          );
        })}

        <Paging defaultPageSize={50} />
      </DataGrid>
        <TasksModalEdit
          saveData={saveData}
          taskEditParent = {saveInfo}
          setSaveInfo = {setSaveInfo}
          show = {props.show}
          handleClose = { props.handleClose }
          getAllData={props.getAllData}
          excludedDates={props.excludedDates}
          onlyForTaskInProject = {true}
        />
    </React.Fragment>
  );
};

export default React.memo(MyTasksByProject);
